// ═══════════════════════════════════════════════════════════════════
// TMS GAMMA — Link de convite/recuperação (#386)
//
// O link do e-mail traz `#access_token=…&type=invite` (ou `recovery`) e já
// entra com sessão — mas sem ninguém ter definido senha. O Supabase apaga o
// hash logo depois de processá-lo, então a leitura tem de ser feita na hora
// em que o módulo carrega.
// ═══════════════════════════════════════════════════════════════════
export function veioDeLinkDeSenha(hash) {
  return /[#&]type=(invite|recovery)(&|$)/.test(hash || "");
}

export const SENHA_MINIMA = 8;

// Devolve a mensagem de erro, ou "" quando a senha serve.
export function validarNovaSenha(senha, confirmacao) {
  if (senha.length < SENHA_MINIMA) return `A senha precisa ter ao menos ${SENHA_MINIMA} caracteres.`;
  if (senha !== confirmacao) return "As senhas não são iguais.";
  return "";
}
